// WP-1.13 (S-38 step 1 "upload CSV"): a small, dependency-free RFC4180-ish CSV parser.
// The file is read and parsed entirely client-side — only the resulting rows (never the raw
// file) are sent to the API for preview/commit.
export interface ParsedCsv {
  readonly headers: string[];
  readonly rows: Record<string, string>[];
}

function tokenizeCsv(text: string): string[][] {
  const lines: string[][] = [];
  let row: string[] = [];
  let field = '';
  let inQuotes = false;
  let i = 0;
  const n = text.length;
  while (i < n) {
    const ch = text[i];
    if (ch === undefined) break;
    if (inQuotes) {
      if (ch === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i += 2;
          continue;
        }
        inQuotes = false;
        i += 1;
        continue;
      }
      field += ch;
      i += 1;
      continue;
    }
    if (ch === '"') {
      inQuotes = true;
      i += 1;
      continue;
    }
    if (ch === ',') {
      row.push(field);
      field = '';
      i += 1;
      continue;
    }
    if (ch === '\r') {
      i += 1;
      continue;
    }
    if (ch === '\n') {
      row.push(field);
      field = '';
      lines.push(row);
      row = [];
      i += 1;
      continue;
    }
    field += ch;
    i += 1;
  }
  if (field !== '' || row.length > 0) {
    row.push(field);
    lines.push(row);
  }
  return lines;
}

export function parseCsv(text: string): ParsedCsv {
  if (text.trim() === '') return { headers: [], rows: [] };
  const lines = tokenizeCsv(text).filter((cells) => !(cells.length === 1 && cells[0] === ''));
  const [headerRow, ...dataRows] = lines;
  const headers = headerRow ?? [];
  const rows = dataRows.map((cells) => {
    const record: Record<string, string> = {};
    headers.forEach((h, idx) => {
      record[h] = cells[idx] ?? '';
    });
    return record;
  });
  return { headers, rows };
}
